var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hero-image',{attrs:{"blockField":_vm.data}},[_c('template',{slot:"title"},[_vm._v(_vm._s(_vm.data.title.data))]),_c('template',{slot:"subtitle"},[_vm._v(_vm._s(_vm.data.subtitle.data))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }